<div>
  <button
    (click)="toggle()"
    [attr.aria-expanded]="isOpen()"
    class="w-full flex items-center justify-between text-left"
    type="button"
  >
    <span class="font-medium text-gray-800">{{ title }}</span>
    <lucide-angular
      [img]="isOpen() ? chevronUp : chevronDown"
      class="text-gray-500 transition-transform duration-300"
      size="20"
    ></lucide-angular>
  </button>

  @if (isOpen()) {
    <div class="pt-3">
        <ng-content></ng-content>
    </div>
  }
</div>
